<template>
    <div class="leading-normal tracking-normal gradient">
        <nuxt />
    </div>
</template>

<script>

export default {
    name: 'Customer'
}
</script>

<style>
    html {
        font-family: 'Source Sans Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI',
        Roboto, 'Helvetica Neue', Arial, sans-serif;
        font-size: 16px;
        word-spacing: 1px;
        -ms-text-size-adjust: 100%;
        -webkit-text-size-adjust: 100%;
        -moz-osx-font-smoothing: grayscale;
        -webkit-font-smoothing: antialiased;
        box-sizing: border-box;
        -ms-text-size-adjust: 100%;
        -webkit-text-size-adjust: 100%;
        -moz-osx-font-smoothing: grayscale;
        -webkit-font-smoothing: antialiased;
        box-sizing: border-box;
    }

    .gradient {
        background: #999;
        /* background: linear-gradient(90deg, #d53369 0%, #daae51 100%); */
        /* background: linear-gradient(90deg, #19b954 0%, #62b581 100%); */
    }
</style>
